import React, { Component } from "react";
import { Table, Card, Row, Col, Button, Image } from "react-bootstrap";
import AddCpvalue from "../Cpvalue/AddCpvalue";
import CpvalueView from "../Cpvalue/CpvalueView";
var dateFormat = require("dateformat");

class Cpvalue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      CpValueShow: false,
    };
  }
  componentDidMount() {
    this.props.fetchCpvalue();
  }

  handleCpValueShow = (item) => {
    this.setState({
      CpValueShow: true,
      CpValueDtls: item,
    });
  };

  handleCloseCpValueShow = () => {
    this.setState({ CpValueShow: false });
  };

  handleAddCpvalue = (item) => {
    this.setState({
      showAddModel: true,
      ItemList: this.props.CpvalueList,
      item: item,
    });
  };
  closeAddModel = () => {
    this.setState({ showAddModel: false });
  };

  render() {
    console.log("#################################", this.props.CpvalueList);
    const item =
      this.props.CpvalueList && this.props.CpvalueList
        ? this.props.CpvalueList && this.props.CpvalueList
        : null;

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Cp Value</h3>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="currencyRecrd">
                  <i className="cui-note cmnRecordIcon" />
                  <span className="cmnPageCount">1</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            {/* <Button
              style={{marginBottom: '15px'}}
              onClick={() => this.handleAddCpvalue()}
            >
              <i className="fa fa-plus fa-md" />
              <span style={{marginLeft: '5px', fontWeight: 'bold'}}>ADD</span>
            </Button>
            <AddCpvalue
              showAddModel={this.state.showAddModel}
              closeAddModel={this.closeAddModel}
              AddCpvalue={this.props.AddCpvalue}
              // CountrysList={this.props.CountrysList}
              // resetPage={this.resetPage}
            /> */}
            <Table responsive className="cmnMainTable" bordered striped>
              <thead>
                <tr className="cmnMainTableHd">
                  <th>Sl No</th>
                  <th style={{ width: "150px" }}>GST</th>
                  <th>Service Fee</th>
                  <th style={{ width: "200px" }}>Service Fee Percentage</th>
                  <th>Gateway Fee</th>
                  <th>Created Date </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> 1</td>
                  <td className="cmn_Cap">{item !== null && item.gst}</td>
                  <td className="cmn_Cap">
                    {item !== null && item.serviceFee}
                  </td>

                  <td className="cmn_Cap">
                    {item !== null && item.serviceFeePer}
                  </td>
                  <td className="cmn_Cap">
                    {item !== null && item.gatewayFee}
                  </td>

                  <td className="cmn_Cap">
                    {item !== null &&
                      item.createdAt !== null &&
                      dateFormat(item.createdAt, "mediumDate")}
                  </td>
                  <td className="cmnViewIcon">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="fa fa-eye fa-lg "
                        onClick={() => this.handleCpValueShow({ item: item })}
                      />
                      <i
                        className="fa fa-edit fa-lg "
                        style={{
                          paddingLeft: 10,
                        }}
                        onClick={() => this.handleAddCpvalue()}
                      />
                      <AddCpvalue
                        showAddModel={this.state.showAddModel}
                        closeAddModel={this.closeAddModel}
                        ItemList={this.state.ItemList}
                        AddCpvalue={this.props.AddCpvalue}
                        // resetPage={this.resetPage}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
            <CpvalueView
              show={this.state.CpValueShow}
              handleClose={this.handleCloseCpValueShow}
              CpValueDtls={this.state.CpValueDtls}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Cpvalue;
